import { render, staticRenderFns } from "./SupportPage.vue?vue&type=template&id=9c3fd81c&scoped=true"
import script from "./SupportPage.vue?vue&type=script&lang=js"
export * from "./SupportPage.vue?vue&type=script&lang=js"
import style0 from "./SupportPage.vue?vue&type=style&index=0&id=9c3fd81c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3fd81c",
  null
  
)

export default component.exports